import UnitModelsList from "./UnitModelsList";

const UnitModelsSetupPage = () => <UnitModelsList />;

export default UnitModelsSetupPage;
